import AbstractApisClient from "./AbstractApisClient";
import * as RouterApis from "./routers";
export class LogonApisClient extends AbstractApisClient {
  constructor(params) {
    super(params);
    this.apps = new RouterApis.LogonApps(this);
  }

}
export const createLogonApisClient = ({
  urlResolver
}) => new LogonApisClient({
  baseUrl: urlResolver.getUrl("mydpd.apis")
});